import { b as _objectSpread2, c as _objectWithoutProperties, d as _slicedToArray, e as _toConsumableArray } from './__generated__-C2sSYBPz.js';
export { g as LanguageCodeEnum, h as LanguageCodeFilterEnum, i as MenuNodeIdTypeEnum, f as PageIdType, T as TemplateEnum } from './__generated__-C2sSYBPz.js';
import React__default, { useState, useEffect } from 'react';
import { d as defaultConfig, c as configContext, L as Link, a as classNames, s as styles, b as styles$1, B as BackgroundImage, e as LinkBox, f as styles$2, u as useConfig, M as MAIN_CONTENT_ID, g as styles$3, P as PageMeta, h as PageContentBreadcrumb, i as PageSection, T as Tag, G as Grid, C as Card } from './archiveSearchPageContent.module-CtBGccQJ.js';
export { S as Carousel, E as Collection, o as ContentContainer, I as EventSearchCollection, F as EventSelectionCollection, H as HtmlToReact, U as Image, ar as LANGUAGE_CODE_ORDINAL_NUMBER, K as LocationsSelectionCollection, k as ModuleItemTypeEnum, N as Navigation, l as Notification, m as Page, n as PageContent, p as PageContentLayout, q as PageMainContent, D as disableBreadcrumbsLastLink, al as filterPagesAndArticles, ao as findLanguage, t as getArticlePageCardProps, A as getBreadcrumbListItems, z as getBreadcrumbsFromPage, x as getCollectionCards, y as getCollectionUIType, r as getCollections, an as getElementTextContent, v as getEventCardProps, J as getEventCollectionCards, w as getLocationCardProps, O as getLocationsCollectionCards, am as getUri, Q as getVenueIds, ac as isArticleType, R as isEventClosed, a5 as isEventSearch, a6 as isEventSearchCarousel, ah as isEventSearchCollection, a7 as isEventSelected, a8 as isEventSelectedCarousel, ag as isEventSelectionCollection, ae as isEventType, aj as isLanguage, a1 as isLayoutArticle, a3 as isLayoutArticleCarousel, X as isLayoutCard, Y as isLayoutCards, W as isLayoutContent, Z as isLayoutImage, _ as isLayoutImageGallery, ab as isLayoutLinkList, a2 as isLayoutPage, a4 as isLayoutPageCarousel, a0 as isLayoutSocialMediaFeed, $ as isLayoutSteps, ak as isLinkItem, a9 as isLocationsSelected, aa as isLocationsSelectedCarousel, ai as isLocationsSelectionCollection, as as isNonEmptyLanguage, ad as isPageType, af as isVenueType, ap as languageSorter, aq as toPrimaryLanguageOption, j as useHeadlessCmsLink, V as useResolveImageUrl } from './archiveSearchPageContent.module-CtBGccQJ.js';
import { IconAngleRight, IconArrowRight, IconSearch, LoadingSpinner, Button, TextInput, IconCrossCircleFill } from 'hds-react';
import '@apollo/client';
import 'isomorphic-dompurify';
import 'html-react-parser';
import 'date-fns';
import 'react-dom';

function ConfigProvider(_ref) {
  var userConfig = _ref.config,
    children = _ref.children;
  var config = React__default.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultConfig), userConfig);
  }, [userConfig]);
  return /*#__PURE__*/React__default.createElement(configContext.Provider, {
    value: config
  }, children);
}

var _excluded = ["className", "children", "variant"];
function SecondaryLink(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    delegatedProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Link, _objectSpread2(_objectSpread2({
    className: classNames(styles.secondaryLink, className)
  }, delegatedProps), variant === 'arrowRight' && {
    iconRight: /*#__PURE__*/React__default.createElement(IconAngleRight, null)
  }), children);
}

function LargeCard(_ref) {
  var id = _ref.id,
    ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    imageUrl = _ref.imageUrl,
    imagePosition = _ref.imagePosition,
    imageLabel = _ref.imageLabel,
    title = _ref.title,
    subTitle = _ref.subTitle,
    text = _ref.text,
    customContent = _ref.customContent,
    hasLink = _ref.hasLink,
    url = _ref.url,
    clampText = _ref.clampText,
    openInNewTab = _ref.openInNewTab,
    withBorder = _ref.withBorder;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var handleToggleActive = function handleToggleActive() {
    return setIsHovered(function (val) {
      return !val;
    });
  };
  var content = /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$1["".concat(imagePosition)], styles$1.cardWrapper, withBorder && styles$1.withBorder, isHovered && styles$1.isHovered)
  }, /*#__PURE__*/React__default.createElement(BackgroundImage, {
    id: id,
    url: imageUrl,
    labelTag: imageLabel,
    className: styles$1.imageWrapper
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.textWrapper
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.title
  }, title), subTitle && /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.subTitle
  }, subTitle), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$1.text, clampText && styles$1.clamp)
  }, text), customContent && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1.customContent
  }, customContent)), url && hasLink && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1.buttonWrapper
  }, /*#__PURE__*/React__default.createElement(Link, {
    tabIndex: -1,
    href: url,
    openInNewTab: openInNewTab,
    iconLeft: /*#__PURE__*/React__default.createElement(IconArrowRight, {
      "aria-hidden": "true"
    }),
    showExternalIcon: false
  })))));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React__default.createElement(React__default.Fragment, null, hasLink ? (/*#__PURE__*/React__default.createElement(LinkBox, {
      id: id,
      href: url,
      className: classNames(styles$1.cardLink, className),
      "aria-label": ariaLabel || '',
      openInNewTab: openInNewTab,
      onMouseEnter: handleToggleActive,
      onMouseLeave: handleToggleActive
    }, content)) : (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React__default.createElement(React__default.Fragment, null, content)))
  );
}

function ArchivePage(_ref) {
  var navigation = _ref.navigation,
    content = _ref.content,
    footer = _ref.footer;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.pageLayout
  }, /*#__PURE__*/React__default.createElement("div", null, navigation), content, footer);
}

function SearchForm(_ref) {
  var archiveSearch = _ref.archiveSearch,
    handleSearch = _ref.handleSearch,
    handleChange = _ref.handleChange,
    searchText = _ref.searchText;
  return /*#__PURE__*/React__default.createElement("form", {
    role: "search",
    className: styles$3.searchForm,
    onSubmit: handleSearch
  }, /*#__PURE__*/React__default.createElement(TextInput, {
    className: classNames(styles$3.inputWithIcon, styles$3.hdsTextInputOverrides),
    name: "q",
    id: "q",
    placeholder: (archiveSearch === null || archiveSearch === void 0 ? void 0 : archiveSearch.searchTextPlaceholder) || '',
    onChange: handleChange,
    value: searchText
  }, /*#__PURE__*/React__default.createElement(IconSearch, {
    "aria-hidden": "true"
  })), /*#__PURE__*/React__default.createElement(Button, {
    theme: "coat",
    type: "submit",
    iconLeft: /*#__PURE__*/React__default.createElement(IconSearch, {
      "aria-hidden": "true"
    }),
    className: styles$3.hdsButtonOverrides
  }, (archiveSearch === null || archiveSearch === void 0 ? void 0 : archiveSearch.searchButtonLabelText) || ''));
}
function SearchTags(_ref2) {
  var tags = _ref2.tags,
    currentTags = _ref2.currentTags,
    hasClearSearch = _ref2.hasClearSearch,
    handleTagClick = _ref2.handleTagClick,
    handleClearSearch = _ref2.handleClearSearch,
    clearAllText = _ref2.clearAllText;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.tagsContainer
  }, /*#__PURE__*/React__default.createElement("div", null, tags.map(function (tag) {
    return /*#__PURE__*/React__default.createElement(Tag, {
      whiteOnly: true,
      key: "tag-".concat(tag.slug),
      selected: currentTags.includes(tag),
      onClick: handleTagClick(tag)
    }, tag.name);
  })), /*#__PURE__*/React__default.createElement("div", null, hasClearSearch && (/*#__PURE__*/React__default.createElement("button", {
    className: styles$3.clearButton,
    onClick: handleClearSearch,
    type: "button"
  }, clearAllText, /*#__PURE__*/React__default.createElement(IconCrossCircleFill, {
    "aria-hidden": true
  }))))));
}
var defaultLargeCard = function defaultLargeCard(item) {
  return /*#__PURE__*/React__default.createElement(LargeCard, _objectSpread2({}, item));
};
var defaultCreateCard = function defaultCreateCard(item) {
  return /*#__PURE__*/React__default.createElement(Card, _objectSpread2({}, item));
};
function ArchiveCollection(_ref3) {
  var items = _ref3.items,
    _ref3$createLargeCard = _ref3.createLargeCard,
    createLargeCard = _ref3$createLargeCard === void 0 ? defaultLargeCard : _ref3$createLargeCard,
    _ref3$createCard = _ref3.createCard,
    createCard = _ref3$createCard === void 0 ? defaultCreateCard : _ref3$createCard,
    _ref3$largeFirstItem = _ref3.largeFirstItem,
    largeFirstItem = _ref3$largeFirstItem === void 0 ? true : _ref3$largeFirstItem;
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  var firstItem = items[0];
  var gridItems = largeFirstItem ? items.slice(1) : items;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.largeCardContainer
  }, largeFirstItem && createLargeCard(firstItem)), /*#__PURE__*/React__default.createElement(Grid, {
    className: styles$3.grid
  }, gridItems.map(function (item) {
    return createCard(item);
  })));
}
function SearchPageContent(props) {
  var breadcrumbs = props.breadcrumbs,
    customContent = props.customContent,
    className = props.className,
    hasMore = props.hasMore,
    isLoading = props.isLoading,
    noResults = props.noResults,
    tags = props.tags,
    currentTags = props.currentTags,
    currentText = props.currentText,
    withQuery = props.withQuery,
    onSearch = props.onSearch,
    onLoadMore = props.onLoadMore,
    page = props.page;
  var _useConfig = useConfig(),
    Head = _useConfig.components.Head,
    archiveSearch = _useConfig.copy.archiveSearch,
    customCopy = _useConfig.customCopy,
    mainContentId = _useConfig.mainContentId;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTags = _useState4[0],
    setSearchTags = _useState4[1];
  useEffect(function () {
    if (withQuery) {
      if ((currentTags === null || currentTags === void 0 ? void 0 : currentTags.length) > 0) {
        setSearchTags(currentTags);
      }
      setSearchText(currentText);
    }
  }, [currentTags, currentText, withQuery]);
  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    onSearch(searchText, searchTags);
  };
  var handleChange = function handleChange(e) {
    setSearchText(e.target.value);
  };
  var handleTagClick = function handleTagClick(tag) {
    return function () {
      if (!isLoading) {
        var selectedTags = _toConsumableArray(searchTags);
        if (selectedTags.includes(tag)) {
          selectedTags = selectedTags.filter(function (selectedTag) {
            return selectedTag !== tag;
          });
        } else {
          selectedTags = [].concat(_toConsumableArray(selectedTags), [tag]);
        }
        setSearchTags(_toConsumableArray(selectedTags));
        onSearch(searchText, selectedTags);
      }
    };
  };
  var clearTags = function clearTags() {
    setSearchTags([]);
    setSearchText('');
    onSearch('', []);
  };
  return /*#__PURE__*/React__default.createElement("main", {
    id: mainContentId !== null && mainContentId !== void 0 ? mainContentId : MAIN_CONTENT_ID,
    className: classNames(styles$3.contentLayout, className)
  }, Head && /*#__PURE__*/React__default.createElement(PageMeta, {
    headComponent: Head,
    page: page
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.mainLayout
  }, breadcrumbs && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$3.breadcrumbs
  }, typeof breadcrumbs === 'function' ? (/*#__PURE__*/React__default.createElement(PageContentBreadcrumb, {
    breadcrumbs: breadcrumbs(page)
  })) : (/*#__PURE__*/React__default.createElement(PageContentBreadcrumb, {
    breadcrumbs: breadcrumbs
  })))), /*#__PURE__*/React__default.createElement(PageSection, {
    korosBottom: true,
    className: styles$3.searchFormContainer,
    korosBottomClassName: styles$3.koros
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.searchFormContainerInner
  }, /*#__PURE__*/React__default.createElement("h1", null, (page === null || page === void 0 ? void 0 : page.title) || archiveSearch.title || ''), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SearchForm, {
    archiveSearch: archiveSearch,
    handleSearch: handleSearch,
    handleChange: handleChange,
    searchText: searchText
  })), tags && (/*#__PURE__*/React__default.createElement(SearchTags, {
    tags: tags,
    hasClearSearch: Boolean(searchText) || (currentTags === null || currentTags === void 0 ? void 0 : currentTags.length) > 0,
    clearAllText: archiveSearch === null || archiveSearch === void 0 ? void 0 : archiveSearch.clearAll,
    currentTags: searchTags,
    handleTagClick: handleTagClick,
    handleClearSearch: clearTags
  })))), customContent && (/*#__PURE__*/React__default.createElement(PageSection, {
    className: styles$3.customContentContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.customContentContainerInner
  }, customContent))), /*#__PURE__*/React__default.createElement(PageSection, {
    className: styles$3.searchResultsContainer
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.searchResultsContainerInner
  }, /*#__PURE__*/React__default.createElement("div", null, noResults ? (/*#__PURE__*/React__default.createElement("div", {
    className: styles$3.noResultsContainer
  }, /*#__PURE__*/React__default.createElement(IconSearch, null), /*#__PURE__*/React__default.createElement("h1", null, archiveSearch.noResultsTitle || ''), /*#__PURE__*/React__default.createElement("p", null, archiveSearch.noResultsText || ''))) : (/*#__PURE__*/React__default.createElement(ArchiveCollection, _objectSpread2({}, props))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$3.bottomActions
  }, isLoading && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$3.loadingSpinner
  }, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    multicolor: true
  }))), !isLoading && hasMore && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$3.loadMoreButton
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: (customCopy === null || customCopy === void 0 ? void 0 : customCopy.loadMoreButtonVariant) || 'secondary',
    theme: (customCopy === null || customCopy === void 0 ? void 0 : customCopy.loadMoreButtonTheme) || 'black',
    type: "button",
    onClick: onLoadMore
  }, (archiveSearch === null || archiveSearch === void 0 ? void 0 : archiveSearch.loadMoreButtonLabelText) || ''))))))))));
}

export { ArchivePage, BackgroundImage, Card, ConfigProvider, LargeCard, Link, LinkBox, PageContentBreadcrumb, PageMeta, PageSection, SearchPageContent, SecondaryLink, Tag as TagComponent, defaultConfig, useConfig };
